import styled from 'styled-components';

export const Text = styled.span<{
  type?: 'isCompany' | 'title' | 'subInfo';
  fontWeight?: number;
  fontSize?: string;
  width?: string;
  isMobile?: boolean;
}>`
  width: ${({ width }) => !!width?.length && width};
  margin-bottom: ${({ type }) => (type === 'title' ? '0' : '12px')};
  margin-right: ${({ type }) => type === 'title' && '8px'};

  color: ${({ type, theme }) => {
    switch (type) {
      case 'isCompany':
        return theme.COLOR.GREY_02;
      default:
        return theme.COLOR.GREY_01;
    }
  }};

  ${({ type, theme, isMobile }) => {
    switch (type) {
      case 'title':
        return theme.FONT.H5;
      case 'isCompany':
        return isMobile ? theme.FONT.B3 : theme.FONT.B2;
      case 'subInfo':
        return theme.FONT.B3;
      default:
        return isMobile ? theme.FONT.B2 : theme.FONT.B1;
    }
  }};

  font-weight: ${({ fontWeight }) => fontWeight && fontWeight};
  font-size: ${({ fontSize }) => fontSize && fontSize};
  line-height: ${({ type }) => !type?.length && '19px'};
`;

export const ListWrapper = styled.div`
  margin-top: 30px;
`;

export const ListLineWrapper = styled.div`
  display: flex;
`;
